export default "__VITE_ASSET___HLacs3L__"